

















import { UserModel } from "../../apis";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonAddCancelShipment extends Vue {
  addShipment() {
    this.$store.commit("ADD_SHIPMENT_CLICK");
  }
  onCancelAdd() {
    return this.$router.push({ name: "shipment" });
  }
}
